import styles from "../QuoteCard/QuoteCard.module.scss";

const TermsAndConditions = () => {
  return (
    <div className={styles.quote__tc}>
      <h4 className={styles.quote__tc_title}>Terms and Conditions</h4>
      <p>
        By adding a trade-in quote to basket, you agree to the{" "}
        <a
          href="https://trade-in.johnlewis.com/home/termsconditions"
          target="_blank"
          rel="noreferrer"
          data-cy="quote-terms-and-conditions"
          data-testid="termsAndConditions:links:link"
        >
          Terms and Conditions
        </a>{" "}
        and{" "}
        <a
          href="https://trade-in.johnlewis.com/home/privacy"
          target="_blank"
          rel="noreferrer"
          data-cy="quote-privacy-notice"
          data-testid="termsAndConditions:links:privacyLink"
        >
          Privacy Notice
        </a>{" "}
        of our partner Likewize.
      </p>
    </div>
  );
};

export default TermsAndConditions;
